











































































































import { Vue, Component, Prop } from 'vue-property-decorator';
import CollapseTransition from '@/components/collapseTransition/collapseTransition.ts';
import DictTypeAdd from '@/views/system/settings/dict/unit/dictTypeAdd.vue';
import { dictServe } from '@/api/installServer';
import { arrayToTree } from '@/util/arrayToTree';
import { TableStripe } from '@/mixins/tableStripe';

@Component({
  components: { DictTypeAdd, CollapseTransition },
  mixins: [TableStripe],
})
export default class DictType extends Vue {
  @Prop(Object) row!: any; // 传递给编辑页面-数据对象
  private loading: any = false; // 表格加载
  private dictVisable: any = 1; // 编辑页展示
  private treeStatus: any = false; // 是否打开节点
  private pid: any = '';
  private rowData: any = {};
  private formShow = false; // 是否显示搜索表单内容

  // 表单数据对象
  private formData: any = {
    label: '', // 字典标签
    value: '', // 字典值
  };

  // 表单数据对象
  private formDict: any = {
    id: '',
    dictId: '', // 上级字典id
    label: '', // 字典标签
    sort: 0, // 排序
    value: '', // 字典值
    newValue: '',
  };

  // 表格的数据对象
  private tableData: any = [];

  /**
         @description: 接收父组件点击字典类型时传的参
         @author: cxf
         @update: cxf 2021/5/27 12:23
         **/
  created() {
    this.pid = this.row.id;
    this.formDict.newValue = this.row.id;
    this.getDictTypeListData(this.row.id);
  }

  /**
   * @desc 获取所有数据
   * @param1 暂无
   * @returns 暂无
   */
  private getDictTypeListData(id: any) {
    this.loading = true;
    // 发起接口请求，获取分页数据
    dictServe
      .sysDictTypeList({
        dictId: id,
        label: this.formData.label ? this.formData.label : null,
        value: this.formData.value ? this.formData.value : null,
      })
      .then((res: any) => {
        this.tableData = arrayToTree(res.data);
        this.loading = false;
      })
      .catch((error: any) => {
        this.loading = false;
        this.$message.error('获取数据失败');
      });
  }

  /**
         @description: 返回上一级
         @author: cxf
         @update: cxf 2021/5/28 13:43
         **/
  private returnLastPage() {
    this.$emit('on-response');
  }

  /**
         @description: 刷新列表
         @author: cxf
         @update: cxf 2021/5/18 18:34
         **/
  private refreshTree() {
    this.getDictTypeListData(this.pid);
  }

  /**
         @description: 展开列表
         @author: cxf
         @update: cxf 2021/5/18 18:34
         **/
  forArr(arr: any, isExpand: any) {
    const treeNode: any = 'treeNode';
    arr.forEach((i: any) => {
      (this.$refs[treeNode] as any).toggleRowExpansion(i, isExpand);
      if (i.children) {
        this.forArr(i.children, isExpand);
      }
    });
  }

  /**
   * @todo 后期需要优化的部分
   * @desc 点击隐藏或查询按钮触发，隐藏或显示搜索表单内容。
   * @param1 暂无
   * @returns 暂无
   */
  isShowForm() {
    this.formShow = !this.formShow;
  }

  /**
   * @todo 后期需要优化的部分
   * @desc 点击新增或编辑按钮触发，跳转到新增或编辑页面.
   * @param1 暂无
   * @returns 暂无
   */
  addAndEditProfession(data: any) {
    this.rowData = data; // 将该行 id 传递到编辑页面
    this.dictVisable = 2; // 进入编辑页面
  }

  /**
   * @todo 后期需要优化的部分
   * @desc 点击查询按钮触发，查询符合条件的内容.
   * @param1 暂无
   * @returns 暂无
   */
  search() {
    this.getDictTypeListData(this.pid);
  }

  /**
   * @todo 后期需要优化的部分
   * @desc 点击重置按钮触发，重置搜索表单内容.
   * @param1 暂无
   * @returns 暂无
   */
  resetForm() {
    this.formData.label = '';
    this.formData.value = '';
    this.getDictTypeListData(this.pid);
  }

  /**
   * @todo 后期需要优化的部分
   * @desc 函数描述
   * @param 删除接口
   * @returns 返回值描述
   */
  deleteData(id: any) {
    this.$confirm('确认要删除该字典数据吗？', '信息', {
      confirmButtonText: '确定',
      cancelButtonText: '取消',
      type: 'warning',
      customClass: 'box--msg',
    })
      .then(() => {
        dictServe
          .deleteDictTypeData(id)
          .then((res: any) => {
            this.getDictTypeListData(this.pid); // 重新渲染表格数据
            this.$message.success('删除成功!');
          })
          .catch((error: any) => {
            this.$message.error('删除失败,请稍后重试!');
          });
      })
      .catch(() => {
        this.$message({
          type: 'info',
          message: '已取消删除！',
        });
      });
  }

  private handleMenuEditResponse() {
    this.dictVisable = 1;
    this.getDictTypeListData(this.pid);
  }
}
